import { useState, useEffect, useCallback } from 'react';
import { getTriageQueue } from '@/services/api';
import type { TriageQueueResponse, TriagePriority } from '@/types/metrics';

interface TriageFilters {
  priority?: TriagePriority;
  category?: string;
  portfolio?: string;
  search?: string;
  page?: number;
  limit?: number;
}

export function useTriage(filters?: TriageFilters) {
  const [data, setData] = useState<TriageQueueResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const priority = filters?.priority;
  const category = filters?.category;
  const portfolio = filters?.portfolio;
  const search = filters?.search;
  const page = filters?.page;
  const limit = filters?.limit;

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const result = await getTriageQueue({ priority, category, portfolio, search, page, limit });
      setData(result);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch triage data'));
    } finally {
      setLoading(false);
    }
  }, [priority, category, portfolio, search, page, limit]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, loading, error, refetch: fetchData };
}
